import { ElementRef, Renderer2 } from '@angular/core';

export class SizeResolver {
  private element: ElementRef;
  private renderer: Renderer2;
  private currentSize: number;

  constructor(element: ElementRef, renderer: Renderer2) {
    this.element = element;
    this.renderer = renderer;
    this.setInitialSize();
  }

  public ensureCorrectSize(): void {
    while (this.textIsLargerThanContainerArea()) {
      this.decreaseFontSizeByOne();
    }
  }

  public decreaseFontSizeByOne(): void {
    this.currentSize--;
    this.setElementFontSizeAndLineHeight();
  }

  public getCurrentSize(): number {
    return this.currentSize;
  }

  private textIsLargerThanContainerArea(): boolean {
    return this.element.nativeElement.scrollWidth > this.element.nativeElement.offsetWidth;
  }

  private setInitialSize(): void {
    let styles = getComputedStyle(this.element.nativeElement);
    this.currentSize = styles.fontSize ? parseInt(styles.fontSize.slice(0, -2)) : 0;
  }

  private setElementFontSizeAndLineHeight(): void {
    let pixels = this.currentSize + 'px';
    this.renderer.setStyle(this.element.nativeElement, 'font-size', pixels);
    this.renderer.setStyle(this.element.nativeElement, 'line-height', pixels);
  }
}
